import { useState, useEffect } from 'react';
import { basePort, getUsernameJwt, headers, isExpiredJwt, renderRedirect, getJwtFromCookies, IsMbrRolePv } from "../../../module_auth/AuthService"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate, useParams } from "react-router-dom";
import { ToastMessage } from "../../../component/common/Toast"
import "cropperjs/dist/cropper.css";
import { plans } from "./TalentCommonUtil"
import { ServiceDisclaimerCard } from "../../common/ServiceDisclaimerCard";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faHourglassHalf, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { TALENT_IMAGE_URL_PREFIX } from "../../../Config";

export function TalentMypage() {
    const { regId } = useParams();

    const [title, setTitle] = useState("");
    const [categoryCode, setCategoryCode] = useState("");
    const [priceValue, setPriceValue] = useState(0);
    const [priceUnit, setPriceUnit] = useState("HOUR");
    const [isPriceNegotiable, setIsPriceNegotiable] = useState(0);
    const [priceNote, setPriceNote] = useState("");
    const [descriptionText, setDescriptionText] = useState("");
    const [expertIntroText, setExpertIntroText] = useState("");
    const [email, setEmail] = useState("");

    const [mbrId, setMbrId] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("/");
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    const [mainPreview, setMainPreview] = useState(null); // 최종 자른 이미지 미리보기 (DataURL)
    const [accessToken, setAccessToken] = useState("");
    const [cityList, setCityList] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedCityId, setSelectedCityId] = useState("");
    const [serviceMode, setServiceMode] = useState("OFFLINE");
    const [nickname, setNickname] = useState("");
    const [cityName, setCityName] = useState("");
    const [updateAt, setUpdateAt] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [hits, setHits] = useState(0);
    const [mainImageUrl, setMainImageUrl] = useState(""); // 메인 이미지 (단일 문자열)

    const [subPreviews, setSubPreviews] = useState(Array(4).fill(null));
    const [selectedPlanCode, setSelectedPlanCode] = useState("");

    const [postStartDate, setPostStartDate] = useState(null);
    const [postEndDate, setPostEndDate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            setRedirectUrl("/login")
            setRedirect(true)
        } else if (!IsMbrRolePv(getJwtFromCookies())) {
            setRedirectUrl("/")
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
            getCityList();
            getTalentService();
        }
    }, []);

    function getTalentService() {
        let url = basePort + '/get/talent/mypage/' + regId; // 재능 상세 API 호출
        setIsLoading(true);
        fetch(url, { method: 'GET', headers })
            .then(async response => {
                const responseBody = await response.json().catch(() => null);

                if (response.status === 404) {
                    throw new Error(responseBody?.message || responseBody?.detail || "해당 서비스를 찾을 수 없습니다.");
                }

                if (!response.ok) {
                    throw new Error(responseBody?.message || responseBody?.detail || "서버 통신 중 오류가 발생했습니다.");
                }

                return responseBody;
            })
            .then(res => {
                console.log("서버 응답 데이터:", res);
                console.log("서버 응답 데이터 이미지:", res.serviceImages);
                // --- 이미지 처리 로직 추가 ---
                if (res.serviceImages && Array.isArray(res.serviceImages)) {
                    const images = res.serviceImages;
                    console.log("images ", images)

                    // 1. 메인 이미지 찾기 (MAIN 타입 중 첫 번째)
                    const mainImgObj = images.find(img => img.imageType === "MAIN");
                    if (mainImgObj) {
                        const fullUrl = `${mainImgObj.fileDirectory}/${mainImgObj.uniqFileName}`;
                        setMainImageUrl(fullUrl);
                        setMainPreview(fullUrl);
                    }

                    // 2. 디테일 이미지 처리 (DETAIL 타입만 필터링 -> sortOrder 정렬 -> 상위 4개)
                    const details = images
                        .filter(img => img.imageType === "DETAIL")
                        .sort((a, b) => a.sortOrder - b.sortOrder)
                        .slice(0, 4);

                    // 서브 이미지 미리보기 초기화
                    const detailUrls = details.map(img => `${img.fileDirectory}/${img.uniqFileName}`);
                    setSubPreviews(prev => {
                        const newPreviews = [...prev];
                        detailUrls.forEach((url, idx) => { newPreviews[idx] = url; });
                        return newPreviews;
                    });
                }

                setTitle(res.title);
                setNickname(res.nickname || "정보 없음");
                setCategoryName(res.categoryName); // 백엔드에서 코드명 대신 한글명을 보내준다고 가정
                setCategoryCode(res.categoryCode)
                setPriceValue(res.priceValue);
                setPriceUnit(res.priceUnit);
                setIsPriceNegotiable(Number(res.isPriceNegotiable) === 1 ? 1 : 0);
                setPriceNote(res.priceNote);
                setDescriptionText(res.descriptionText || "");
                setExpertIntroText(res.expertIntroText || "");
                const nextSelectedCityId = res.selectedCityId || "";
                const nextIsRemote = res.isRemote === 1;

                setSelectedCityId(nextSelectedCityId)
                if (!nextIsRemote) {
                    setServiceMode("OFFLINE");
                } else if (!nextSelectedCityId) {
                    setServiceMode("REMOTE");
                } else {
                    setServiceMode("HYBRID");
                }
                setCityName(res.cityName)
                setUpdateAt(res.updateAt);
                setHits(res.hits)
                setEmail(res.email)
                setSelectedPlanCode(res.selectedPlanCode)
                setPostStartDate(res.postStartDate)
                setPostEndDate(res.postEndDate)
            })
            .catch(error => {
                console.log(error);
                alert(error.message || "해당 서비스를 찾을 수 없습니다.");
                navigate('/talent_list_mypage');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    function getCityList() {
        let url = basePort + '/get/config'
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCityList(response.cityEntityList)

                let cityOptions = response.cityEntityList.map(city => ({
                    value: city.id,    // 도시 객체의 'id'를 'value'로 매핑
                    label: city.cityName   // 도시 객체의 'name'을 'label'로 매핑
                }));
                setOptions(cityOptions);

            }).catch(error => console.log(error))
    }

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', position: 'relative' }}>
            {renderRedirect(redirect, redirectUrl)}
            <main className="page landing-page" style={{ opacity: isLoading ? 0.45 : 1, pointerEvents: isLoading ? 'none' : 'auto' }}>
                <section className="container" style={{ paddingTop: '100px', paddingBottom: '80px' }}>

                    {/* 상단 헤더 & 브레드크럼 */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0 bg-transparent">
                                <li className="breadcrumb-item text-muted">마이페이지</li>
                                <li className="breadcrumb-item active text-muted">재능 서비스</li>
                            </ol>
                        </nav>
                    </div>

                    <div className="card border-0 shadow-sm overflow-hidden" style={{ borderRadius: '15px' }}>
                        <div className="card-header bg-white border-bottom p-4">
                            <h4 className="mb-0 fw-bold"><i className="bi bi-pencil-square me-2 text-primary"></i>서비스 정보</h4>
                            <p className="text-muted small mb-0 mt-1">등록된 서비스의 상세 정보를 확인하는 페이지입니다.</p>
                        </div>

                        <div className="card-body p-4 p-md-5">
                            {/* 1. 기본 정보 섹션 */}
                            <div className="section-group mb-5">
                                <h5 className="fw-bold mb-4 border-start border-4 border-primary ps-3">기본 정보</h5>
                                <div className="mb-4">
                                    <label className="form-label fw-semibold text-secondary">서비스 제목</label>
                                    <input className="form-control form-control-lg border-2 shadow-none" type="text"
                                        value={title} onChange={(e) => setTitle(e.target.value)}
                                        style={{ fontSize: '1.1rem' }} disabled />
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">진행 방식</label>
                                        <div className="border rounded-3 px-3 py-2 bg-light">
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceModeView"
                                                    id="serviceModeOfflineView"
                                                    checked={serviceMode === "OFFLINE"}
                                                    readOnly
                                                    disabled
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeOfflineView" style={{ opacity: 1 }}>
                                                    대면
                                                </label>
                                            </div>
                                            <div className="form-check mb-2">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceModeView"
                                                    id="serviceModeRemoteView"
                                                    checked={serviceMode === "REMOTE"}
                                                    readOnly
                                                    disabled
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeRemoteView" style={{ opacity: 1 }}>
                                                    온라인/원격
                                                </label>
                                            </div>
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="serviceModeView"
                                                    id="serviceModeHybridView"
                                                    checked={serviceMode === "HYBRID"}
                                                    readOnly
                                                    disabled
                                                />
                                                <label className="form-check-label text-secondary" htmlFor="serviceModeHybridView" style={{ opacity: 1 }}>
                                                    하이브리드(대면/온라인)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">활동 도시</label>
                                        <select
                                            className="form-select"
                                            value={selectedCityId}
                                            onChange={(e) => setSelectedCityId(e.target.value)}
                                            disabled
                                        >
                                            <option value="">도시 선택</option>
                                            {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                        </select>
                                        {serviceMode === "REMOTE" && (
                                            <div className="form-text text-muted mt-2">
                                                온라인/원격 선택 시 활동 도시는 선택되지 않습니다.
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">카테고리</label>
                                        <select className="form-select border-2 shadow-none" disabled value={categoryCode} onChange={(e) => setCategoryCode(e.target.value)}>
                                            <option value="">카테고리 선택</option>
                                            <option value="CAT01">번역/통역 (관공서·비즈니스)</option>
                                            <option value="CAT02">서류 대행/행정 컨설팅 (비자·보험)</option>
                                            <option value="CAT03">독일어/외국어 레슨</option>
                                            <option value="CAT04">IT/개발/데이터</option>
                                            <option value="CAT05">디자인/영상 제작</option>
                                            <option value="CAT06">취업/이직 컨설팅 (독일 CV·면접)</option>
                                            <option value="CAT07">현지 가이드</option>
                                            <option value="CAT08">음악/예체능 레슨</option>
                                            <option value="CAT09">홈케어/수리/이사 지원</option>
                                            <option value="CAT10">비즈니스/마케팅</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">가격 설정 (유로)</label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-light border-2 border-end-0">€</span>
                                            <input className="form-control border-2 shadow-none" type="number" disabled value={priceValue} onChange={(e) => setPriceValue(e.target.value)} />
                                            <select className="form-select border-2 shadow-none" value={priceUnit} disabled onChange={(e) => setPriceUnit(e.target.value)}>
                                                <option value="HOUR">시간당</option>
                                                <option value="ONCE">회당</option>
                                                <option value="DAY">일당</option>
                                            </select>
                                        </div>
                                        <div className="form-check mt-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="isPriceNegotiableCheckbox"
                                                checked={isPriceNegotiable === 1}
                                                onChange={(e) => setIsPriceNegotiable(e.target.checked ? 1 : 0)}
                                                disabled
                                            />
                                            <label
                                                className="form-check-label text-secondary"
                                                htmlFor="isPriceNegotiableCheckbox"
                                                style={{ opacity: 1, color: '#6c757d' }}
                                            >
                                                가격 협의
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">노출 플랜</label>
                                        <select
                                            className="form-select border-2 shadow-none"
                                            value={selectedPlanCode}
                                            onChange={(e) => setSelectedPlanCode(e.target.value)}
                                            // [핵심] 수정 모드일 때는 선택 불가 처리
                                            disabled
                                            style={{ backgroundColor: '#e9ecef', cursor: 'not-allowed' }}
                                        >
                                            <option value="">플랜 선택</option>
                                            {plans.map((plan, index) => (
                                                <option key={index} value={plan.code}>
                                                    {plan.title} ({plan.price === "0원" ? "무료" : plan.price})
                                                </option>
                                            ))}
                                        </select>

                                        {/* 수정 모드일 때만 보여주는 안내 문구 */}
                                        <div className="mt-1 small text-danger">
                                            <i className="bi bi-exclamation-triangle-fill me-1"></i>
                                            등록된 플랜은 수정할 수 없습니다. 변경을 원하시면 고객센터로 문의해 주세요.
                                        </div>
                                    </div>
                                    {/* [신규 추가] 서비스 기간 컬럼 */}
                                    <div className="col-md-6 mb-4">
                                        <label className="form-label fw-semibold text-secondary">서비스 제공 기간</label>
                                        <div
                                            className="form-control border-2 d-flex align-items-center"
                                            style={{
                                                backgroundColor: '#f8f9fa',
                                                minHeight: '38px',
                                                color: (!postStartDate || !postEndDate) ? '#6c757d' : '#212529'
                                            }}
                                        >
                                            {!postStartDate ? (
                                                /* 데이터가 없을 때 (검수 중) */
                                                <div className="text-muted d-flex align-items-center">
                                                    <FontAwesomeIcon icon={faHourglassHalf} className="me-2" />
                                                    <span className="fw-normal">검수 진행 중 (승인 후 기간이 표시됩니다)</span>
                                                </div>
                                            ) : (
                                                /* 데이터가 있을 때 (날짜 표시) */
                                                <div className="d-flex align-items-center" style={{ color: '#212529' }}>
                                                    <FontAwesomeIcon icon={faCalendarCheck} className="me-2 text-primary" />
                                                    <span className="fw-normal">{postStartDate}</span>

                                                    {/* 물결(~) 대신 화살표 아이콘 사용 */}
                                                    <FontAwesomeIcon icon={faArrowRight} className="mx-3 text-secondary" style={{ fontSize: '0.8rem' }} />

                                                    <span className="fw-normal">{postEndDate}</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="mt-1 small text-muted">
                                            {(!postStartDate || !postEndDate)
                                                ? "운영진 확인 후 서비스 시작일이 확정됩니다."
                                                : "해당 기간 동안 서비스가 노출됩니다."}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="section-group mb-5 pt-4 border-top col-md-6">
                                <h5 className="fw-bold mb-3 border-start border-4 border-info ps-3">대표 이미지</h5>
                                <div className="p-4 border rounded-3 bg-light">
                                    <div className="row align-items-center">
                                        {/* 왼쪽: 미리보기 및 직접 클릭 수정 영역 */}
                                        <div className="col-md-5 col-lg-4 d-flex justify-content-center">
                                            <div
                                                className="position-relative border rounded-3 bg-white shadow-sm overflow-hidden"
                                                style={{
                                                    width: '212px',
                                                    height: '159px',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s'
                                                }}

                                            >
                                                {mainPreview ? (
                                                    <>
                                                        <img
                                                            src={TALENT_IMAGE_URL_PREFIX + mainPreview}
                                                            alt="Main Preview"
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                        />
                                                        {/* 이미지 위 오버레이 (이미지 변경 안내) */}
                                                        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-25 opacity-0 hover-opacity-100 transition-opacity"
                                                            style={{ transition: 'opacity 0.2s' }}>
                                                            <span className="badge bg-dark px-3 py-2">이미지 변경</span>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-center p-3">
                                                        <i className="bi bi-plus-circle text-muted display-6"></i>
                                                        <div className="small text-muted mt-2">사진을 등록해주세요</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 3. 상세 설명 섹션 */}
                            <div className="section-group mb-5 pt-4 border-top">
                                <h5 className="fw-bold mb-4 border-start border-4 border-warning ps-3">서비스 상세 내용</h5>
                                <div className="mb-5 pb-3">
                                    <label className="form-label fw-semibold">서비스 상세 설명</label>
                                    <ReactQuill
                                        theme="snow"
                                        value={descriptionText}
                                        onChange={setDescriptionText}
                                        // [핵심] 읽기 전용 모드 활성화
                                        readOnly={true}
                                        // [추천] 툴바를 숨겨서 완전한 조회용 화면으로 만듦
                                        modules={{ toolbar: false }}
                                        style={{
                                            height: '300px',
                                            marginBottom: '70px',
                                            backgroundColor: '#f8f9fa' // 읽기 전용임을 나타내는 배경색
                                        }}
                                    />
                                </div>
                                {/* 2. 상세 이미지 섹션 (상세 설명 바로 아래 배치) */}
                                <div className="section-group mb-5 mt-5 pt-5 pt-md-2">
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h5 className="fw-bold mb-0 border-start border-4 border-info ps-3">서비스 상세 이미지</h5>
                                        <span className="badge bg-light text-dark border px-3">최대 4장</span>
                                    </div>

                                    <div className="p-4 border rounded-3 bg-white">
                                        {/* 안내 문구 수정: '등록해주세요' -> '등록된 상세 이미지입니다' */}
                                        <p className="text-muted small mb-4">
                                            <i className="bi bi-info-circle me-1"></i> 서비스 결과물이나 작업 과정이 담긴 상세 이미지입니다.
                                        </p>

                                        <div className="row g-3">
                                            {Array.from({ length: 4 }).map((_, index) => {
                                                // 확인 페이지이므로 기존 DB에 저장된 이미지(subPreviews) 존재 여부만 체크
                                                const imageUrl = subPreviews[index];
                                                const hasFile = !!imageUrl;

                                                return (
                                                    <div key={index} className="col-6 col-sm-4 col-md-3">
                                                        <div
                                                            className={`position-relative border rounded-3 d-flex align-items-center justify-content-center overflow-hidden ${!hasFile ? 'bg-light' : ''}`}
                                                            style={{
                                                                aspectRatio: '1 / 1',
                                                                cursor: 'default', // 클릭 불가
                                                                borderStyle: hasFile ? 'solid' : 'dashed',
                                                                borderWidth: '1px',
                                                                borderColor: '#dee2e6'
                                                            }}
                                                        // onClick 이벤트 완전 제거
                                                        >
                                                            {hasFile ? (
                                                                /* 1. 이미지가 있는 경우: 이미지부만 노출 (삭제/교체 버튼 제거) */
                                                                <img
                                                                    src={TALENT_IMAGE_URL_PREFIX + imageUrl}
                                                                    alt={`Sub ${index + 1}`}
                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                />
                                                            ) : (
                                                                /* 2. 이미지가 없는 경우: 빈 칸 표시 */
                                                                <div className="text-center text-muted opacity-50">
                                                                    <i className="bi bi-image d-block mb-1" style={{ fontSize: '1.5rem' }}></i>
                                                                    <span style={{ fontSize: '12px' }}>미등록</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="section-group mb-5 mt-5">
                                {/* 헤더 부분: 상세 이미지 섹션과 동일한 스타일 적용 */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="fw-bold mb-0 border-start border-4 border-warning ps-3">전문가 소개</h5>
                                    {/* <span className="badge bg-light text-dark border fw-normal">선택 사항</span> */}
                                </div>

                                <div className="mb-4">
                                    {/* 에디터 영역 */}
                                    <ReactQuill
                                        theme="snow"
                                        value={expertIntroText}
                                        onChange={setExpertIntroText}
                                        readOnly={true}
                                        modules={{ toolbar: false }}
                                        style={{
                                            height: '250px',
                                            marginBottom: '50px',
                                            backgroundColor: '#f8f9fa' // 읽기 전용임을 나타내는 배경색
                                        }}
                                    />
                                </div>
                            </div>

                            {/* 4. 커뮤니케이션 채널 (디자인 카드) */}
                            <div
                                className="card border rounded-4 shadow-sm mb-5 bg-white"
                                style={{ marginTop: '75px' }} // 원하는 픽셀값으로 미세 조정
                            >
                                <div className="card-body p-4">
                                    <h5 className="fw-bold mb-4 text-dark">
                                        <i className="bi bi-headset me-2 text-primary"></i>커뮤니케이션 채널
                                    </h5>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="small fw-bold text-muted">이메일 주소</label>
                                            <div className="input-group">
                                                <span className="input-group-text border-0 bg-secondary text-white"><i className="bi bi-envelope"></i></span>
                                                <input className="form-control border bg-light shadow-none" type="email" disabled value={email} onChange={(e) => setEmail(e.target.value)} placeholder="contact@email.com" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ServiceDisclaimerCard />


                            {/* 등록 버튼 */}
                            <div className="text-center pt-4 mb-5">
                                {/* 버튼들을 한 열로 나열하기 위해 d-flex와 justify-content-center 사용 */}
                                <div className="d-flex align-items-center justify-content-center gap-3">

                                    {/* 1. 목록으로 가기 버튼 (연한 회색 계열) */}
                                    <button
                                        className="btn btn-outline-secondary px-4 py-2 shadow-sm d-inline-flex align-items-center justify-content-center"
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            minWidth: '140px'
                                        }}
                                        type="button"
                                        onClick={() => navigate('/talent_list_mypage')} // 목록 페이지 경로로 이동
                                    >
                                        <i className="bi bi-list-ul me-2"></i>
                                        <span>목록으로</span>
                                    </button>

                                    {/* 2. 수정하러 가기 버튼 (브랜드 컬러/파란색 계열) */}
                                    <button
                                        className="btn btn-primary px-4 py-2 shadow-sm d-inline-flex align-items-center justify-content-center"
                                        style={{
                                            borderRadius: '8px',
                                            fontWeight: '600',
                                            fontSize: '1rem',
                                            minWidth: '140px'
                                        }}
                                        type="button"
                                        onClick={() => {
                                            navigate('/talent_edit_mypage/' + regId);
                                        }}

                                    >
                                        <i className="bi bi-pencil-square me-2"></i>
                                        <span>수정하기</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ToastMessage show={showToast} msg={msgToast} />
            </main>
            {isLoading && (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(128, 128, 128, 0.22)',
                        zIndex: 1050
                    }}
                >
                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </div>
    );
}